import React, { useState, useContext } from "react";


const MainContext = React.createContext();

export const MainProvider = ({ children }) => {
  const [language,setLanguage]=useState(localStorage?.getItem("lang") || 'fr')
  const [modalTitle,setModalTitle]=useState("");
  const [selectedPack,setSelectedPack]=useState("");
  const [showGenericModal,setShowGenericModal]=useState(false);
  const handleLanguageChange=(lang)=>
    {
        localStorage.setItem("lang",lang)
        setLanguage(lang);
        window.open("/home","_self")
    }
  return (
    <MainContext.Provider
      value={{ 
        language,
        handleLanguageChange,
        modalTitle,setModalTitle,
        selectedPack,setSelectedPack,
        showGenericModal,setShowGenericModal
       }}
    >
      {children}
    </MainContext.Provider>
  );
};
export const useMainContext = () => {
  return useContext(MainContext);
};
